import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetWinnersLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_WINNERS_LOTTERY
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetWinnersLotteryAction({
                    data: data.data,
                    page: data.count,
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetWinnersLottery as SetGetWinnersLottery
}